import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '/app/environments/environment';

interface SetCorporatePayload {
  corporateName: string;
  email: string;
  name: string;
  familyName: string;
}

@Injectable({
  providedIn: 'root'
})
export class CorporateService {

  constructor(private httpClient: HttpClient) { }

  public getCorporates() {
    return this.httpClient.get(environment.api + "/corporates");
  }

  public setCorporates(payload: SetCorporatePayload) {
    return this.httpClient.post(environment.api + "/auth/sign-up", payload);
  }

}
